<template>

    <div class="page p-visit_add">
        <the-dashboard-heading :back-href="{ name: 'PatientShow', params: { id: patient.id } }">
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <router-link :to="{ name: 'PatientShow', params: { id: patient.id } }">{{ patientName }}</router-link>
                <span>Przebieg wizyty</span>
            </h2>
        </the-dashboard-heading>
        <the-dashboard-content>
            <visit-form
                v-model="visit"
                @submit="saveVisit">
            </visit-form>
        </the-dashboard-content>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'

import VisitForm from 'Components/Visit/VisitForm'

export default {

    name: 'ViewPatientVisitEdit',

    computed: {
        ...mapGetters(['patient', 'visit']),

        patientName() {
            let name = this.patient.first_name + ' ' + this.patient.last_name
            return name.trim()
        },
    },

    methods: {
        saveVisit() {
            this.$store.dispatch('VISIT_END', this.$route.params.id1).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message)
                this.$router.push({
                    name: 'PatientShow',
                    params: {id: this.$route.params.id}
                })
            }).catch((e) => {
                this.$alert.error('Przebieg wizyty', e.response.data.message)
            })
        }
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        store.dispatch('VISIT_LAST_RESET')
        Promise.all([
            store.dispatch('VISIT_FETCH', to.params.id1),
            store.dispatch('VISIT_ATTACHMENTS_FETCH', {visitId: to.params.id1, type: 'formal-documents'}),
            store.dispatch('VISIT_ATTACHMENTS_FETCH', {visitId: to.params.id1, type: 'diagnostic-tests'}),
            store.dispatch('PHT_FETCH'),
            store.dispatch('PATIENT_FETCH', to.params.id),
            store.dispatch('PHT_FETCH')
        ]).then(() => {
            if (store.getters.visit.status === 'started') {
                store.dispatch('VISIT_LAST_FETCH').then(() => {
                    store.dispatch('PAGE_LOADING_RESET')
                    next()
                })
            } else {
                store.dispatch('PAGE_LOADING_RESET')
                next()
            }
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        VisitForm
    }

}

</script>
